import { render } from "./Chapter.vue?vue&type=template&id=47442d62&scoped=true&ts=true"
import script from "./Chapter.vue?vue&type=script&lang=ts"
export * from "./Chapter.vue?vue&type=script&lang=ts"

import "./Chapter.vue?vue&type=style&index=0&id=47442d62&lang=stylus"
import "./Chapter.vue?vue&type=style&index=1&id=47442d62&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47442d62"]])

export default __exports__